// extracted by mini-css-extract-plugin
export default {"iFrame":"iFrame--xOdfh"};